import { render, staticRenderFns } from "./error-boundary.vue?vue&type=template&id=6107022c&scoped=true&"
import script from "./error-boundary.vue?vue&type=script&lang=js&"
export * from "./error-boundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107022c",
  null
  
)

export default component.exports